import { DcaAllocation, DcaStrategy, DcaTransactions } from "@/types/dca";
import axiosInstance from "./axiosInstance";
import { AxiosResponse } from 'axios';
import { DataLineChart, ParamsChart } from "@/types/common";
import { TransactionFilterParams } from '@/types/filters';
import { cleanFilterParams } from '@/core/utils/filters';

export class DcaService {
  private static readonly GET_LIST_DCA_STRATEGY_ENDPOINT = 'app/dca-strategies';

  private static readonly CREATE_DCA_STRATEGY_ENDPOINT = 'app/dca-strategies';
  private static readonly UPDATE_DCA_STRATEGY_ENDPOINT = 'app/dca-strategies';
  private static readonly GET_DCA_STRATEGY_ENDPOINT = 'app/dca-strategies';
  private static readonly GET_ALL_DCA_MODEL_ENDPOINT = 'app/users/binance/dca-models';
  private static readonly GET_DCA_STRATEGY_REPORT_ENDPOINT = 'app/dca-strategies';

  public static async getListDcaStrategy(): Promise<DcaStrategy[]> {
    const res: AxiosResponse<DcaStrategy[]> = await axiosInstance.get(DcaService.GET_LIST_DCA_STRATEGY_ENDPOINT);
    return res.data;
  }

  public static async createDCAStrategy(data: DcaStrategy): Promise<DcaStrategy> {
    const res: AxiosResponse<DcaStrategy> = await axiosInstance.post(DcaService.CREATE_DCA_STRATEGY_ENDPOINT, data);
    return res.data;
  }

  public static async updateDCAStrategy(data: DcaStrategy): Promise<DcaStrategy> {
    const res: AxiosResponse<DcaStrategy> = await axiosInstance.patch(`${DcaService.UPDATE_DCA_STRATEGY_ENDPOINT}/${data.id}`, data);
    return res.data;
  }

  public static async getDCAStrategy(id: string): Promise<DcaStrategy> {
    const res: AxiosResponse<DcaStrategy> = await axiosInstance.get(`${DcaService.GET_DCA_STRATEGY_ENDPOINT}/${id}`);
    return res.data;
  }

  public static async getAllDCAModel(): Promise<DcaStrategy[]> {
    const res: AxiosResponse<DcaStrategy[]> = await axiosInstance.get(DcaService.GET_ALL_DCA_MODEL_ENDPOINT);
    return res.data;
  }

  public static async getDcaAllocations(id: string): Promise<DcaAllocation[]> {
    const res: AxiosResponse<DcaAllocation[]> = await axiosInstance.get(`${DcaService.GET_DCA_STRATEGY_ENDPOINT}/${id}/allocations`);
    return res.data;
  }

  public static async getDcaTransactions(params: { id: string, offset?: number, limit?: number, filters?: TransactionFilterParams }): Promise<DcaTransactions> {
    const { id, offset = 0, limit = 10, filters } = params;
    const res: AxiosResponse<DcaTransactions> = await axiosInstance.get(`${DcaService.GET_DCA_STRATEGY_ENDPOINT}/${id}/transactions`, {
      params: {
        offset,
        limit,
        ...cleanFilterParams(filters),
      }
    });
    return res.data;
  }

  public static async getDcaStrategyReport(params: ParamsChart): Promise<DataLineChart> {
    const { id, period } = params;
    const res: AxiosResponse<DataLineChart> = await axiosInstance.get(`${DcaService.GET_DCA_STRATEGY_REPORT_ENDPOINT}/${id}/report`, {
      params: {
        period
      }
    });
    return res.data;
  }
}
